import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  url = '/',
  image,
  type = 'website',
  noindex = false,
  canonical,
  structuredData
}) => {
  const defaultTitle = 'Utility Tools - Free Online PDF Converter & Productivity Tools';
  const defaultDescription = 'Powerful utility tools that work entirely in your browser. Convert files, process documents, and enhance productivity with ease.';
  const defaultKeywords = 'PDF converter, utility tools, online converter, document conversion, file processing, productivity tools, browser tools';
  const siteUrl = window.location.origin;
  
  const seoTitle = title ? `${title} | Utility Tools` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoUrl = `${siteUrl}${url}`;
  const seoCanonical = canonical || seoUrl;
  const seoImage = image || `${siteUrl}/logo192.png`;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      <link rel="canonical" href={seoCanonical} />
      
      {/* Open Graph tags */}
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:site_name" content="Utility Tools" />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;